import { forwardRef } from "react";
import styles from "./m3.module.css";

/**
 * Outlined card surface used for tables, charts and grouped content.
 * Replaces the Paper "Table Container" / "Chart Container" boilerplate.
 *
 * @param {boolean} elevated - adds elevation level 1
 * @param {boolean} padded - adds the standard 24px inner padding
 * @param {string} component - HTML element to render (default "section")
 */
const M3Surface = forwardRef(({ children, elevated = false, padded = false, component: Component = "section", className = "", style }, ref) => (
  <Component
    ref={ref}
    className={`${styles.surface} ${elevated ? styles.surfaceElevated : ""} ${padded ? styles.surfacePadded : ""} ${className}`}
    style={style}
  >
    {children}
  </Component>
));

M3Surface.displayName = "M3Surface";

export default M3Surface;
